export enum WIDGET_COMPONENT {
  select = 'select',
  entity_select = 'entity-select',
  label = 'label',
  toolbar = 'toolbar',
  edit_grid = 'edit-grid',
  edit_grid_custom = 'edit-grid-custom',
  commission_rate_assignment_grid = 'commission-rate-assignment-grid',
  grid_list = 'grid-list',
  color_picker = 'color-picker',
  panel = 'panel',
  panel_group = 'panel-group',
  switch = 'switch',
  checkbox = 'checkbox',
  input_radio = 'input-radio',
  input_checkbox = 'input-checkbox',
  checkbox_group = 'checkbox-group',
  input = 'input',
  textarea = 'textarea',
  input_date = 'input-date',
  input_number = 'input-number',
  input_currency = 'input-currency',
  site_selection_list = 'site-selection-list',
  select_event_with_grid_modal = 'select-event-with-grid-modal',
  select_site_with_grid_modal = 'select-site-with-grid-modal',
  entity_form_list = 'entity_form_list',
  multiple_label = 'multiple-label',
  xux_xiv_input = 'xux-xvi-input',
  xux_datepicker = 'xux-datepicker',
  progress_bar = 'progress_bar',
  multiple_selection_list = 'multiple_selection_list',

  // for drag
  transfer_summary = 'transfer_summary',
  order_summary = 'order_summary',
  event_summary = 'event_summary',
  inventory_value = 'inventory_value',
  purchase_order_summary = 'purchase_order_summary',
  stand_worksheet_summary = 'stand_worksheet_summary',
}
